import React from 'react';
import { useCurrency } from '../../context/CurrencyContext';
import './ExistingInvestmentModal.css';

const ExistingInvestmentModal = ({ isOpen, onClose, existingInvestment, stockSymbol, onNavigateToInvestment }) => {
  const { formatCurrency } = useCurrency();

  if (!isOpen || !existingInvestment) return null;

  const getStatusBadge = () => {
    const { status_display } = existingInvestment;
    
    const statusColors = {
      'Active': '#10b981',
      'Matured': '#3b82f6',
      'Partially Withdrawn': '#f59e0b'
    };

    return (
      <span 
        className="status-badge"
        style={{ 
          backgroundColor: statusColors[status_display] || '#666',
          color: 'white',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '600'
        }}
      >
        {status_display}
      </span>
    );
  };

  return (
    <div className="existing-investment-modal-overlay" onClick={onClose}>
      <div className="existing-investment-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>×</button>

        <div className="modal-header">
          <div className="warning-icon">⚠️</div>
          <h2>Active Investment Found</h2>
          <p>You already have an investment in <strong>{stockSymbol}</strong></p>
        </div>

        <div className="investment-details-card">
          <div className="detail-header">
            <h3>Current Investment Details</h3>
            {getStatusBadge()}
          </div>

          <div className="detail-row">
            <span className="label">Current Value:</span>
            <span className="value highlight">{formatCurrency(parseFloat(existingInvestment.current_value))}</span>
          </div>

          <div className="detail-row">
            <span className="label">Total Invested:</span>
            <span className="value">{formatCurrency(parseFloat(existingInvestment.total_invested))}</span>
          </div>

          <div className="detail-row">
            <span className="label">Profit/Loss:</span>
            <span className={`value ${parseFloat(existingInvestment.profit_loss) >= 0 ? 'profit' : 'loss'}`}>
              {parseFloat(existingInvestment.profit_loss) >= 0 ? '+' : ''}
              {formatCurrency(parseFloat(existingInvestment.profit_loss))}
            </span>
          </div>

          {existingInvestment.can_withdraw && (
            <div className="withdrawal-notice">
              <div className="notice-icon">💰</div>
              <div className="notice-text">
                <strong>Withdrawal Available!</strong>
                <p>You can withdraw from this investment now.</p>
              </div>
            </div>
          )}
        </div>

        <div className="info-section">
          <h4>📋 What This Means:</h4>
          <ul>
            <li>You cannot create a new investment in {stockSymbol} while you have an active one</li>
            <li>You must <strong>withdraw completely</strong> from your current investment first</li>
            <li>Once withdrawn, you can create a fresh investment in this stock</li>
          </ul>
        </div>

        <div className="modal-actions">
          <button 
            className="action-btn view-btn"
            onClick={() => {
              onNavigateToInvestment(existingInvestment.id);
              onClose();
            }}
          >
            🔍 View Investment Details
          </button>
          {existingInvestment.can_withdraw && (
            <button 
              className="action-btn withdraw-btn"
              onClick={() => {
                onNavigateToInvestment(existingInvestment.id);
                onClose();
              }}
            >
              💸 Withdraw Funds
            </button>
          )}
        </div>

        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ExistingInvestmentModal;